import * as React from 'react';
import { WithSearch } from '@elastic/react-search-ui';
import * as _ from 'lodash';
import { Config } from '../../helper';
import AccordionItem, { AccordionSize } from '../../../AccordionItem';
import { getFieldValue } from './helper';
import { Actions, Body, Markdown, DescriptionList, buildExtraFields } from './accordion';

export default function AccordionSearchResult(props) {
  const {displayOptions} = props;
  const {mapping = {}} = displayOptions;

  return (
    <WithSearch mapContextToProps={({results, wasSearched}) => ({results, wasSearched})}>
      {({results, wasSearched}) => {
        if (!wasSearched) return null;

        if (results.length === 0) {
          return <p className='h--smaller mb-4'>{Config.I18n.Hits.NoResults}</p>;
        }

        return (
          <div className='search-results search-results--accordion'>
            {results.map(r => {
              const fieldValue = (fieldName, defaultValue) => {
                return getFieldValue(r, mapping, fieldName, defaultValue) || defaultValue;
              };

              const rawId = _.get(r, 'id.raw', '');
              const index = _.get(r, '_meta.rawHit._index', '');
              const itemId = `os-accordion-${index}-${rawId}`;
              const image = fieldValue(Config.Mapping.Accordion.ImageURL, null);
              const title = fieldValue(Config.Mapping.Accordion.Title, '');
              const badge = fieldValue(Config.Mapping.Accordion.Badge, '');
              const body = fieldValue(Config.Mapping.Accordion.Body, '');
              const markdown = fieldValue(Config.Mapping.Accordion.Markdown, '');
              const descriptionList = buildExtraFields(r, mapping);
              const rawLinks = fieldValue(Config.Mapping.Accordion.Links, []);
              const links = [];

              if (Array.isArray(rawLinks)) {
                rawLinks.forEach(link => {
                  if (link?.url) {
                    links.push({text: link.text || Config.I18n.Hits.LearnMore, url: link.url});
                  }
                });
              } else if (typeof rawLinks === 'string' && rawLinks.length) {
                links.push({text: Config.I18n.Hits.LearnMore, url: rawLinks});
              }

              return (
                <AccordionItem
                  key={itemId}
                  id={itemId}
                  title={title}
                  badge={badge}
                  image={image}
                  size={AccordionSize.smallest.id}>
                  <Body content={body}/>
                  <Markdown content={markdown}/>
                  <DescriptionList list={descriptionList}/>
                  <Actions links={links}/>
                </AccordionItem>
              );
            })}
          </div>
        );
      }}
    </WithSearch>
  );
}
